// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"357":"9b57e53c","741":"88d428e7","865":"5d23003e"}[chunkId] + ".css";
};